import * as Yup from 'yup';

// User sign up form validation
export const addUserValidationSchema = Yup.object({
    hierarchyLevel: Yup.string().required('Please select an option'),
    partner: Yup.string().when('hierarchyLevel', {
        is: (val) => val === 'NPI',
        then: Yup.string().optional(),
        otherwise: Yup.string().required('Partner is required'),
    }),
    partnerOfPartner: Yup.string(),
    firstName: Yup.string().required('Please enter a first name'),
    lastName: Yup.string().required('Please enter a last name'),
    mobileNumber: Yup.string()
        .matches(/^[0-9]*$/, 'Mobile number must only contain numbers')
        .max(20, 'Mobile number must be at most 20 characters')
        .required('Mobile number is required'),
    emailAddress: Yup.string().email('Enter a valid email').required('Email is required'),
    userRole: Yup.string().required('Please select an option'),
});

export const editUserDetailsValidationSchema = Yup.object({
    firstName: Yup.string().required('Please enter a first name'),
    lastName: Yup.string().required('Please enter a last name'),
    phoneNumber: Yup.string()
        .matches(/^[0-9]*$/, 'Mobile number must only contain numbers')
        .max(20, 'Mobile number must be at most 20 characters')
        .required('Mobile number is required'),
    emailAddress: Yup.string().email('Enter a valid email').required('Email is required'),
    userRole: Yup.string().required('Please select an option'),
});

export const addUserRoleValidationSchema = Yup.object({
    name: Yup.string().required('Please enter a role name'),
    hierarchyLevel: Yup.string().required('Please select Hierarchy Level'),
});

export const editUserRoleValidationSchema = Yup.object({
    role: Yup.string().required('Please enter a role name'),
    hierarchyLevel: Yup.string().required('Please select an option'),
});

export const validateIBAN = (iban: string): boolean => {
    /**
     * Explanation of the regex pattern:
     *
     * ^ - Start of the string.
     * [A-Z]{2} - Matches exactly 2 uppercase letters (country code).
     * \d{2} - Matches exactly 2 digits (check number).
     * [A-Za-z0-9]{4} - Matches exactly 4 alphanumeric characters (bank code).
     * \d{6} - Matches exactly 6 digits (bank branch code).
     * \d{8} - Matches exactly 8 digits (bank account number).
     * $ - End of the string.
     */
    const regex = /^[A-Z]{2}\d{2}[A-Za-z0-9]{4}\d{6}\d{8}$/;
    return regex.test(iban);
};

export const validateBIC = (bic: string): boolean => {
    /**
     * Explanation of the regex pattern:
     *
     * ^ - Start of the string.
     * [A-Z]{4} - Matches exactly 4 uppercase letters (bank code).
     * [A-Z]{2} - Matches exactly 2 uppercase letters (country code).
     * [0-9A-Z]{2} - Matches exactly 2 alphanumeric characters (location code).
     * [0-9A-Z]{3} - Matches exactly 3 alphanumeric characters (branch code).
     * $ - End of the string.
     */
    const regex = /^[A-Z]{4}[A-Z]{2}[0-9A-Z]{2}[0-9A-Z]{3}?$/;
    return bic.length >= 8 && bic.length <= 11 && regex.test(bic);
};

export const maskString = (value: string): string => {
    const maskedValue = value.slice(-4).padStart(value.length, '*');
    return maskedValue;
};

export const isEmailValid = (email) => {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
};
export const partnerResourceValidationSchema = Yup.object().shape({
    resource_name: Yup.string().required('Required'),
    description: Yup.string().required('Required'),
    viewAccessPermissions: Yup.string().required('Required'),
    resource_type: Yup.string().required('Required'),
    resourceURL: Yup.string().required('Required'),
    imageUrl: Yup.string().required('Required'),
    section: Yup.number().required('Required').typeError('Required'),
});

export const partnerResourceSectionValidationSchema = Yup.object().shape({
    sectionName: Yup.string().required('Required'),
});
